module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_4000_Inactive@1x-b88ee1e5deb678dfcb8e247c829eeca7.png";